/* v8 ignore start */
import {createSlice} from "@reduxjs/toolkit";

import {TRootState} from "@/store";

interface IPlayerState {
  isPlaying: boolean;
}

const initialState: IPlayerState = {
  isPlaying: false,
};

const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    play: (state) => {
      state.isPlaying = true;
    },
    pause: (state) => {
      state.isPlaying = false;
    },
    musicTrackPreviewed: (state) => {
      state.isPlaying = false;
    },
  },
});

export const {play, pause, musicTrackPreviewed} = playerSlice.actions;

export const selectIsAnimationPlaying = (state: TRootState) => state.player.isPlaying;

export default playerSlice.reducer;
/* v8 ignore stop */
